import { apiAxios } from "./apiConfig";

export interface CmsFile {
  id: string;
  name: string;
  maskName: string;
  path: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CmsFileResponse {
  status: boolean;
  data: CmsFile;
}

export const getCmsFileById = async (id: string): Promise<CmsFileResponse> => {
  const response = await apiAxios.get(`/file/${id}`);
  return response.data;
};

export interface UploadCmsFileResponse {
  status: boolean;
  data: string; // <-- fileId
}

/**
 * Upload file to CMS
 * usedFor: 'thumbnail' | 'attachment'
 */
export const uploadCmsFile = async (
  file: File,
  usedFor: "thumbnail" | "attachment" | "lesson",
): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("usedFor", usedFor);

  const response = await apiAxios.post<UploadCmsFileResponse>(
    "/file/upload",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data.data;
};
